import * as _ from 'underscore'
import { DataProvider } from "../helpers"
import { OpConsumerType } from "../models/core/op-consumer-type"
import { ColumnInfo } from "../models/custom"
import { Enums } from "../models/common"

export class DataProviderConsumerType {

    // #region Ctor

    constructor(private dataProvider: DataProvider) { }

    // #endregion


    // #region Public Methods

    public deleteConsumerType = (opObj: OpConsumerType): JQueryPromise<void> => {
        return this.dataProvider.sendRequestWithSession('OpxDeleteConsumerType', { ToBeDeleted: opObj.toJSON() }, null)
    }

    public getConsumerType = (id: number): JQueryPromise<OpConsumerType> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetConsumerType', { IdConsumerType: id }, 'OpxGetConsumerTypeResult')
            .then((response: Object) => {
                if (response != null) {
                    const result: OpConsumerType = new OpConsumerType(response)

                    return OpConsumerType
                        .loadNavigationProperties(this.dataProvider, [result])
                        .then((consumerType: OpConsumerType[]) => _.first(consumerType))
                }

                return null
            })
    }

    public getConsumerTypeFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string): JQueryPromise<{ objects: any[], totalCount: number, error: { code: any, msg: any } }> => {
        return this.dataProvider.sendFilterRequestWithSession<OpConsumerType>([], 0, 0, '', Enums.ReferenceType.IdConsumerType, 'OpxConsumerTypeFilter', 'OpxConsumerTypeFilterResult')
    }

    public saveConsumerType = (toBeSaved: OpConsumerType): JQueryPromise<OpConsumerType> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveConsumerType', { ToBeSaved: toBeSaved.toJSON() }, 'OpxSaveConsumerTypeResult')
            .then((response: any) => {
                if (response != null) {
                    const result: OpConsumerType = new OpConsumerType(response)

                    return OpConsumerType
                        .loadNavigationProperties(this.dataProvider, [result])
                        .then((consumerType: OpConsumerType[]) => _.first(consumerType))
                }

                return null
            })
    }

    // #endregion
}
